<template lang="">
    <b-form-select
        id="selected"
        v-model="selected"
        :options="options"
        required
        @focus="clearErrorField('selected')"
>  </b-form-select>
</template>
<script>
export default {
    data(){
        return {
            selected: null,
            options: [
                { value: null, text: "ANNULER" },
                { value: 1, text: "EN ATTENTE" },
                { value: 2, text: "TERMINER" },
                { value: 3, text: "REPROGRAMMER" },
                { value: 4, text: "PROGRAMMER" },
                { value: 5, text: "EFFECTUER" },
                { value: 5, text: "MANQUER" },
                // { value: 'b', text: 'Selected Option', disabled: true },
            ],
        }
    }
}
</script>